<template>
  <v-card>
    <v-card-title>
      Zentralpostfach
    </v-card-title>
    <v-card-subtitle>
    </v-card-subtitle>
    <v-card-text
    >
      <v-text-field
        style="width: 50%"
        v-model="message_search"
        label="Suche"
        outlined
        dense
        clearable
        prepend-icon="mdi-magnify"
        hide-details
      >

      </v-text-field>
      <v-row>
        <v-col
          cols="6"
        >
          <v-checkbox
            v-model="show_eingehende"
          >
            <template
              v-slot:label
            >
              <v-icon
                class="mr-1 green--text"
              >
                mdi-download
              </v-icon>
              Eingehende anzeigen
            </template>
          </v-checkbox>
        </v-col>
        <v-col
          cols="6"
        >
          <v-checkbox
            v-model="show_ausgehende"
          >
            <template
              v-slot:label
            >
              <v-icon
                class="mr-1 red--text"
              >
                mdi-upload
              </v-icon>
              Ausgehende anzeigen
            </template>
          </v-checkbox>

        </v-col>
      </v-row>
      <v-divider class="mt-1"></v-divider>
      <v-timeline
        align-top
        dense
        style="height: 64vh; overflow-y: auto"
      >
        <v-timeline-item
          v-for="message in filtered_messages"
          :key="message.time"
          color="primary"
          :icon="(message.srcSSI == $store.state.device.issi) ? 'mdi-upload' : 'mdi-download'"
          :icon-color="(message.srcSSI == $store.state.device.issi) ? 'red' : 'green'"
        >
          <div
          >
            <div
              class="font-weight-normal"
            >
              <!-- <strong>
                {{ (message.srcSSI == $store.state.device.issi) ?
                ((message.destSSI in get_Engine_by_ISSI) ? get_Engine_by_ISSI[message.destSSI].display_name : message.destSSI)
                :
                ((message.srcSSI in get_Engine_by_ISSI) ? get_Engine_by_ISSI[message.srcSSI].display_name : message.srcSSI)
                }}
                </strong> -->
              <strong
                v-if="message.srcSSI == $store.state.device.issi"
                style="float:left;"
              >
                <Status
                  v-if="message.destSSI in get_Engine_by_ISSI"
                  :engine="get_Engine_by_ISSI[message.destSSI]"
                  :replace_status_with_display-name="true"
                >
                </Status>
                <div
                  v-else
                >
                  {{message.destSSI}}
                </div>
              </strong>
              <strong
                v-if="message.destSSI == $store.state.device.issi"
                style="float:left;"
              >
                <Status
                  v-if="message.srcSSI in get_Engine_by_ISSI"
                  :engine="get_Engine_by_ISSI[message.srcSSI]"
                  :replace_status_with_display-name="true"
                >
                </Status>
                <div
                  v-else
                >
                  {{message.srcSSI}}
                </div>
              </strong>
              {{(message.ts != null) ? ("@" + formate_time(message.ts) + " Uhr") : ''}}
              <v-btn
                icon
                small
                @click="new_sds = {receiver: message.srcSSI == $store.state.device.issi ? [message.destSSI] : [], text: message.text, flash_sds: message.flash_sds, copy_to_station: message.copy_to_station}"
              >
                <v-icon
                >
                  mdi-forward
                </v-icon>
              </v-btn>
            </div>
            <div>


              <v-icon
                v-if="message.unread && message.destSSI == $store.state.device.issi"
                :class="(blink_source) ? 'warning--text' : 'primary--text'"
                x-large
                @click="mark_as_read(message.id)"
              >
                mdi-email-mark-as-unread
              </v-icon>
              {{ message.text }}
            </div>
            <v-progress-linear
              v-if="!message.confirmed"
              style="width: 50%"
              height="15"
              indeterminate
            >Senden...</v-progress-linear>
          </div>

        </v-timeline-item>
      </v-timeline>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "Postfach",
  data: () => ({
    searchinput: null,
    show_eingehende: true,
    show_ausgehende: true,
    message_search: '',

    blink_source: false,
    blink_interval: null
  }),
  computed: {
    filtered_messages() {
      return this.$store.state.message_center.messages.filter(message =>
          (message.srcSSI == this.$store.state.device.issi && this.show_ausgehende ||
            message.destSSI == this.$store.state.device.issi && this.show_eingehende
          )
          && (
            message.text.toLowerCase().includes(this.message_search.toLowerCase()) ||
            message.srcSSI.includes(this.message_search.toLowerCase()) ||
            message.destSSI.includes(this.message_search.toLowerCase())  ||
            (message.srcSSI in this.get_Engine_by_ISSI && this.get_Engine_by_ISSI[message.srcSSI].display_name.toLowerCase().includes(this.message_search.toLowerCase())) ||
            (message.destSSI in this.get_Engine_by_ISSI && this.get_Engine_by_ISSI[message.destSSI].display_name.toLowerCase().includes(this.message_search.toLowerCase()))
          )
      ).reverse()
    },
  },
  created() {
    this.$store.dispatch("update", { "context": "/messages" })
    /*if(this.$store.state.message_center.messages == null || this.$store.state.message_center.messages.length == 0){
      this.$store.dispatch("update", { "context": "message/list" })
     }*/
  }
};
</script>

<style scoped>

</style>
